(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDeleteController',ChannelConfDeleteController);

    ChannelConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChannelConf'];

    function ChannelConfDeleteController($uibModalInstance, entity, ChannelConf) {
        var vm = this;
        vm.channelConf = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ChannelConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
